export var AgentWalletTransferType;
(function (AgentWalletTransferType) {
    AgentWalletTransferType["TRANSFER"] = "transfer";
    AgentWalletTransferType["DEPOSIT"] = "deposit";
    AgentWalletTransferType["WITHDRAW"] = "withdraw";
    AgentWalletTransferType["AGENT_EXCHANGE"] = "agent_exchange";
    AgentWalletTransferType["MANUAL_DEPOSIT"] = "manual_deposit";
    AgentWalletTransferType["THIRD_PARTY_DEPOSIT"] = "third_party_deposit"; //自行上點
})(AgentWalletTransferType || (AgentWalletTransferType = {}));
//# sourceMappingURL=AgentWalletTransferType.js.map